import { ref } from 'vue'
import { consola } from 'consola'
import { defineStore } from 'pinia'
import { modalStateEnum } from './modalStateEnum'

const logger = consola.withTag('modal-store')

interface ModalData {
  userData?: Record<string, unknown>
  formData?: Record<string, unknown>
  [key: string]: unknown
}

export const useModalStore = defineStore('modal', () => {
  const isOpen = ref(false)
  const currentState = ref<modalStateEnum>(modalStateEnum.Login)
  const previousStates = ref<modalStateEnum[]>([])
  const modalData = ref<ModalData>({})

  const open = (state: modalStateEnum, data?: ModalData) => {
    logger.debug('open', { state, data })

    if (currentState.value !== state) {
      previousStates.value.push(currentState.value)
    }
    currentState.value = state
    isOpen.value = true
    if (data) {
      modalData.value = { ...modalData.value, ...data }
    }
  }

  const close = () => {
    isOpen.value = false
    previousStates.value = []
    modalData.value = {}
  }

  const setState = (state: modalStateEnum) => {
    previousStates.value.push(currentState.value)
    currentState.value = state
  }

  const back = () => {
    if (previousStates.value.length > 0) {
      currentState.value = previousStates.value.pop()!
    } else {
      close()
    }
  }

  const updateModalData = (data: Partial<ModalData>) => {
    modalData.value = { ...modalData.value, ...data }
  }

  return {
    isOpen,
    currentState,
    previousStates,
    modalData,
    open,
    close,
    setState,
    back,
    updateModalData,
  }
})
